import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeCardPrintFiltering } from './Pages';

export const EmployeeCardPrintRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EmployeeCardPrintFiltering} />
    </Fragment>
)